import { Typography } from '@creditas-ui/react';
import { usePageView } from '@/shared/application/hooks';
import { useNavigateForm } from '@/shared/application/hooks/useNavigateForm';
import { ContinueButton } from '@/shared/ui';
import { Logo } from '@/shared/ui/Logo';
import * as S from './login.styles';

const LoginDecision = (): JSX.Element => {
  usePageView();
  const { goToLogin, goToAutofinLogin } = useNavigateForm();

  return (
    <S.Wrapper>
      <S.LoginLogoSection>
        <Logo />
        <Typography
          variant="headingLgLight"
          color="neutral.90"
          style={{ paddingBottom: '5px', marginTop: '40px' }}
        >
          Qual plataforma você quer acessar?
        </Typography>
        <Typography variant="bodyMdRegular" color="neutral.60">
          É só escolher a opção que você vai utilizar.
        </Typography>
        <ContinueButton
          width="flexible"
          type="button"
          onClick={goToLogin}
          text="Portal do parceiro"
          marginTop="60px"
        />
        <ContinueButton
          width="flexible"
          type="button"
          onClick={goToAutofinLogin}
          text="Financiamento de veículos"
          marginTop="20px"
          marginBottom="60px"
        />
        <Typography variant="bodyMdRegular" color="neutral.60">
          Ficou alguma dúvida? Entre em contato com consultor responsável pela sua parceria
          Creditas.
        </Typography>
      </S.LoginLogoSection>
    </S.Wrapper>
  );
};

export { LoginDecision };
